import { DictType } from "@pma/types"
import axios from "axios"
import { useEffect, useState } from "react"
import { Button } from "@components/common/button"
import { Download } from "lucide-react"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/common/tooltip"
import useTranslator from "@hooks/use-translator"

interface Props {
  file?: DictType
  files?: DictType[]
  showText?: boolean
}

const DownloadFile = ({ file, files, showText }: Props) => {
  const { translate, locale } = useTranslator()
  const [downloadLink, setDownloadLink] = useState("")
  const downloadFile = () => {
    axios({
      url: file?.file,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      setDownloadLink(url)
    })
  }

  const handleFiles = () => {
    files?.forEach((val) => {
      axios({
        url: val?.file,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const download = document.createElement("a")
        download.href = url
        download.download = val.name
        download.click()
      })
    })
  }
  useEffect(() => {
    if (file) {
      downloadFile()
    }
  }, [])

  return (
    <Tooltip>
      <TooltipTrigger>
        {file && (
          <a href={downloadLink} download={file?.name}>
            <Button
              size={showText ? "sm" : "icon"}
              className={`h-6 ${showText ? "flex gap-2 rounded-md bg-slate-200/50 px-3 py-1 shadow" : "w-7"} `}
              variant={"ghost"}
              aria-label='Download'
            >
              {showText && <span className='text-xs'>{translate("Download File")}</span>}
              <Download size={14} />
            </Button>
          </a>
        )}
        {files && (
          <Button
            variant='outline'
            className={`flex flex-row gap-2 ${locale === "he" ? "sm:w-[120px] md:w-min" : "sm:w-[110px] md:w-min"} items-center justify-between hover:bg-slate-300`}
            size={"sm"}
            onClick={handleFiles}
          >
            <Download size={14} />
            <span className='hidden min-w-[30px] flex-1 text-left text-[12px] sm:block sm:text-[10px]'>
              {`${translate("Download selected files")}`}
            </span>
          </Button>
        )}
      </TooltipTrigger>
      {file && <TooltipContent>{translate("Download")}</TooltipContent>}
      {files && <TooltipContent>{translate("Download files in your device")}</TooltipContent>}
    </Tooltip>
  )
}

export default DownloadFile
